// componente per la visualizzazione e gestione della tabella contenente tutti i pannelli (componente destra)
// nella pagina "Pannelli"

import { Component, ViewChild, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { AvailablesService } from '../availables.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';;
import { Availables } from '../availables.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '../../../../service/authentication.service';
import { UtilsService } from '../../../../service/helper/utils.service';
import { AvailablesComponent } from '../availables.component';

@Component({
  selector: 'app-availables-list',
  templateUrl: './availables-list.component.html',
  styleUrls: ['style.scss']
})
export class AvailablesListComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private subscription: Subscription;

  // inizializzazione array con tutti i pannelli da mostrare nella tabella
  dataSource: MatTableDataSource<Availables>;

  // inizializzazione id, profilo e array con tutti gli indici dei messaggi nella tabella
  public id: number
  profile: string
  index = []
  filterValues = {};
  filterSelectObj = [];
  // colonne da mostrare nella tabella (ciascuna etichetta è definita nella pagina html)
  displayedColumns: string[] = ['lastname', 'firstname', 'card', 'email', 'telephone', 'profile', 'enabled', 'bodyid', 'tag', 'actions', 'reset'];
  // displayedColumns: string[] = ['lastname', 'firstname',  'card', 'email', 'telephone', 'role', 'profile', 'enabled', 'bodyid', 'tag', 'actions'];

  constructor(private availablesComponent: AvailablesComponent, private authenticationService: AuthenticationService, private availablesService: AvailablesService,
    private changeDetectorRefs: ChangeDetectorRef, private utilsService: UtilsService) {
    this.filterSelectObj = [
      {
        name: 'Cognome',
        columnProp: 'lastname',
        options: []
      }, {
        name: 'Nome',
        columnProp: 'firstname',
        options: []
      }, {
        name: 'Tessera',
        columnProp: 'card',
        options: []
      }, {
        name: 'Email',
        columnProp: 'email',
        options: []
      }, {
        name: 'Telefono',
        columnProp: 'telephone',
        options: []
      }, {
        name: 'Profilo',
        columnProp: 'profile',
        options: []
      },{
        name: 'Abilitato',
        columnProp: 'enabled',
        options: []
      }, {
        name: 'ID ente',
        columnProp: 'bodyid',
        options: []
      }, {
        name: 'Tag',
        columnProp: 'tag',
        options: []
      }
    ]
  }

  // metodi necessari per aggiornare la tabella in seguito ad interazioni (modifiche, aggiunte, cancellazioni)
  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();

  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = this.createFilter();
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  filterChange(filter, event) {
    //let filterValues = {}
    filter.columnProp == "enabled" ? (event.target.value == "No" ? this.filterValues[filter.columnProp] = false : this.filterValues[filter.columnProp] = true) : this.filterValues[filter.columnProp] = event.target.value
    this.dataSource.filter = JSON.stringify(this.filterValues)
  }
  // Reset table filters
  resetFilters() {
    this.filterValues = {}
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
    })
    this.dataSource.filter = "";
  }
  getFilterObject(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    var ret = []
    if (key == 'enabled') {
      ret = ["Si", "No"]
    } else {
      ret = uniqChk.sort()
    }
    return ret;
  }
  // Custom filter method fot Angular Material Datatable
  createFilter() {
    let filterFunction = function (data: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);

      var found = 0
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '') {
          if (data[col] === searchTerms[col]) {
            found++
          }

        } else {
          delete searchTerms[col];
        }
      }
      return found == Object.keys(searchTerms).length
    }
    return filterFunction
  }


  ngOnInit(): void {
    this.getData();
    this.availablesService.refresh$.subscribe(res => {
      this.getData();
    })
  }
  getData() {
    var me = this
    me.utilsService.showLoader()

    // si imposta il profilo corrente
    this.profile = this.authenticationService.currentUserValue.profile

    // si richiede all'apposito servizio la lista di pannelli e si popola la tabella, applicandone le opportune opzioni
    // (dal paginator, al sort)
    this.dataSource = new MatTableDataSource(this.availablesService.getAvailables());
    this.subscription = this.availablesService.availablesChanged.subscribe(
      (availabless: Availables[]) => {

        this.dataSource = new MatTableDataSource(availabless);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento

        this.dataSource.filterPredicate = this.createFilter();
        this.filterSelectObj.filter((o) => {
          o.options = this.getFilterObject(this.availablesService.getAvailables(), o.columnProp);
        });
        this.changeDetectorRefs.detectChanges();
        this.resetFilters()
        this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento


      }
    );
  }


  isEdit() {
    return this.availablesComponent.isedit
  }
  change() {
    this.availablesComponent.isedit = !this.availablesComponent.isedit
  }
  // metodo richiamato al click del pulsante "modifica" in una riga della tabella
  onEdit(val) {
    var id = val.id
    this.availablesService.editAvailables(id);
    this.change()
  }

  // metodo richiamato alla chiusura della pagina "Pannelli"
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // metodo richiamato dalla componente "PanelEdit": permette di riempire la form di modifica messaggio con tutti i dati
  // relativi al messaggio il cui ID viene indicato in ingresso
  getIndex(ids) {
    this.dataSource = new MatTableDataSource(this.availablesService.getAvailables());
    this.index = []
    for (var i = 0; i < this.dataSource.filteredData.length; i++) {
      this.index.push({
        "id": this.dataSource.filteredData[i].id,
        "edit": i
      })
    }
    var result = this.index.find(obj => {
      return obj.id == ids
    })
    return result.edit
  }
  downloadFile(data, filename = 'data') {
    // let csvData = this.ConvertToCSV(data, ['firstname', 'lastname', 'card', 'email', 'telephone', 'role', 'profile', 'enabled', 'bodyid', 'tag']);
    let csvData = this.ConvertToCSV(data, ['firstname', 'lastname', 'card', 'email', 'telephone', 'profile', 'enabled', 'bodyid', 'tag']);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray, headerList) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    array.forEach(function (v) {
      delete v.id
      delete v.timestamp
      delete v.password
    });
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}` + '\r\n';
    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}` + '\r\n';
      return str.replace(/['"]+/g, '');
    }, str.replace(/['"]+/g, ''));
  }
  download() {
    this.downloadFile(this.availablesService.getAvailables(), 'reperibili');
  }
}
